export default {
  SET_PARENT_CATEGORY: "VOTING_FORM_SET_PARENT_CATEGORY",
  SET_QUERY: "VOTING_FORM_SET_QUERY",
  TOGGLE_LOADING: "VOTING_FORM_TOGGLE_LOADING",
  TOGGLE_PAGINATION_LOAD: "VOTING_FORM_TOGGLE_PAGINATION_LOAD",
  SET_CAMPAIGN: "VOTING_FORM_SET_CAMPAIGN",
  SET_USER_ID: "VOTING_FORM_SET_USER_ID",
  SET_INITIAL_VOTES: "VOTING_FORM_SET_INITIAL_VOTES",
  SUBMIT_ERROR: "VOTING_FORM_SUBMIT_ERROR",
  ADD_CAMPAIGN: "VOTING_FORM_ADD_CAMPAIGN",
  REMOVE_CAMPAIGN: "VOTING_FORM_REMOVE_CAMPAIGN",
  SET_VOTES: "VOTING_FORM_SET_VOTES",
  SET_VALIDATING: "VOTING_FORM/SET_VALIDATING",
  SET_AUTO_VOTE: "VOTING_FORM/SET_AUTO_VOTE",
  SET_DONATION_ID: "VOTING_FORM/SET_DONATION_ID",
  RESET_SEARCH_FILTERS: "VOTING_FORM/RESET_SEARCH_FILTERS",
  RESET_SELECTED_VOTES: "VOTING_FORM/RESET_SELECTED_VOTES",
};
